import { useSelector } from 'react-redux';

import {
    getMode,
    getRolesAsArray,
    getUser,
    getUserCreationRequest,
} from '../../selectors';

export const useMode = () => useSelector(getMode);
export const useUser = () => useSelector(getUser);
export const useRoles = () => useSelector(getRolesAsArray);
export const useCreationRequest = () => useSelector(getUserCreationRequest);
